{
    "Address": "Adres",
    "Bank Account": "Bank",
    "CofC Number": "KvK",
    "P.O. Box 9663": "Postbus 9663",
    "The Netherlands": "Nederland",
    "VAT Number": "BTW"
}
